import { defineNuxtRouteMiddleware } from '#imports';
import { getIsNativeRoutingEnabled, redirectToCorrectPath } from '~~/helpers/routes/oldUrlPrefixRedirection';

export default defineNuxtRouteMiddleware((to /* , from */) => {

  const { path, query } = to;

  const oldPrefixForCategoryCmsPage = '/category/';
  const oldPrefixForCategorySearchPage = '/search/';
  const isNativeRoutingEnabled = getIsNativeRoutingEnabled();

  if (path.includes(oldPrefixForCategoryCmsPage)) {

    return redirectToCorrectPath({
      oldPrefix: oldPrefixForCategoryCmsPage,
      path,
      query,
      isNativeRoutingEnabled,
    });

  }

  if (path.includes(oldPrefixForCategorySearchPage)) {

    return redirectToCorrectPath({
      oldPrefix: oldPrefixForCategorySearchPage,
      path,
      query,
    });

  }

  return;

});
